import { takeLeading } from 'redux-saga/effects';
import { callApi } from 'helpers/saga-helpers';
import { isNull } from 'lodash';

import {
  REQUEST_GET_USERS_INBOXES,
  REQUEST_GET_MANAGERS_BAWABA,
  REQUEST_UPDATE_ASSIGNEMENT_INBOXES,
  REQUEST_COUNT_INBOXES,
} from 'containers/AttributionManager/constants';
import {
  requestSetUsersInboxes,
  requestSetManagersBawaba,
  setCountInboxes,
} from 'containers/AttributionManager/action';
import accessTokenStorage from 'containers/services/security/access-token-storage';

export function* requestGetUsersInboxes(): Generator<unknown> {
  const token = accessTokenStorage.get().token;
  if (isNull(token)) return;
  const path = `/corporeal/user-inboxes`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  yield callApi(path, {}, options, [], requestSetUsersInboxes);
}
export function* requestGetUsersInboxesSaga() {
  yield takeLeading(REQUEST_GET_USERS_INBOXES, requestGetUsersInboxes);
}
export function* requestGetManagersBawaba(): Generator<unknown> {
  const token = accessTokenStorage.get().token;
  if (isNull(token)) return;
  const path = `/corporeal/user-privileges/corporeal-managers`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  yield callApi(path, {}, options, [], requestSetManagersBawaba);
}

export function* requestGetManagersBawabaSaga() {
  yield takeLeading(REQUEST_GET_MANAGERS_BAWABA, requestGetManagersBawaba);
}
export function* requestUpdateAssignementInboxes(action: {
  type: string;
  payload: any;
  successCallBack: Function;
}): Generator<unknown> {
  const token = accessTokenStorage.get().token;
  if (isNull(token)) return;
  const path = `/corporeal/user-inboxes/change-assignement-inboxe`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...action.payload }),
  };
  const errorResponse = yield callApi(path, {}, options, []);
  if (!errorResponse) {
    yield action.successCallBack();
  }
}
export function* requestUpdateAssignementInboxesSaga() {
  yield takeLeading(
    REQUEST_UPDATE_ASSIGNEMENT_INBOXES,
    requestUpdateAssignementInboxes,
  );
}
export function* requestGetCountInboxes(): Generator<unknown> {
  const token = accessTokenStorage.get().token;
  if (isNull(token)) return;
  const path = `/corporeal/notification-manager/get-inboxes-count`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  yield callApi(path, {}, options, [], setCountInboxes);
}
export function* requestGetCountInboxesSaga() {
  yield takeLeading(REQUEST_COUNT_INBOXES, requestGetCountInboxes);
}
export default [
  requestGetUsersInboxesSaga,
  requestGetManagersBawabaSaga,
  requestUpdateAssignementInboxesSaga,
  requestGetCountInboxesSaga,
];
